export default {
    driver_performance_editCoachPanel_editCoachPanel_title: "Reasignar Supervisor",
    driver_performance_editCoachPanel_title_card_p1: "Asignar un supervisor a ",
    driver_performance_editCoachPanel_title_card_p2: " caso de rendimiento",
    driver_performance_editCoachPanel_status: "Estado",
    driver_performance_editCoachPanel_caseId: "ID del caso",
    driver_performance_editCoachPanel_currentCoach: "Supervisor Actual",
    driver_performance_editCoachPanel_unassignedCoach: "Supervisor sin Asignar",
    driver_performance_editCoachPanel_selectCoach: "Seleccionar Supervisor",
    driver_performance_editCoachPanel_saveSuccessfully: "Supervisor fue actualizado correctamente",
    driver_performance_editCoachPanel_saveError: "Se produjo un error reasignando el supervisor",
    driver_performance_editCoachPanel_save: "Guardar",
    driver_performance_editCoachPanel_cancel: "Cancelar"
}